import { Component } from '@angular/core';
import { BaseComponent } from './base-component';

@Component({
  template: ''
})
export abstract class BaseAuthComponent extends BaseComponent {
  abstract parseAuthFlow(): void;
}
